import request from '@/utils/request'

// -------------------- /order/buyer/ --------------------

// 买家订单分页查询
export function getBuyerOrderList(params) {
    return request({
        url: '/order/buyer/order/manage/page',
        method: 'get',
        params
    })
}

// 买家订单详情查询
export function getBuyerOrderDetail(orderCode) {
    return request({
        url: '/order/buyer/order/manage/detail/' + orderCode,
        method: 'get'
    })
}

// 买家修改订单信息
export function modifyOrderInfo(data) {
    return request({
        url: '/order/buyer/order/manage/update',
        method: 'put',
        data
    })
}

// 买家签收订单
export function signOrder(orderCode) {
    return request({
        url: '/order/buyer/order/manage/receive/' + orderCode,
        method: 'post'
    })
}

// 买家签收评价
export function orderEvaluate(data) {
    return request({
        url: '/order/buyer/order/manage/evaluate',
        method: 'post',
        data
    })
}

// 买家取消订单
export function buyerCancelOrder(data) {
    return request({
        url: '/order/buyer/order/manage/cancel',
        method: 'post',
        data
    })
}

// 买家取消订单申请
export function buyerCancelOrderApply(orderCode) {
    return request({
        url: '/order/buyer/order/manage/cancel/' + orderCode,
        method: 'get'
    })
}

// 签收并支付货款
export function signAndPay(data) {
    return request({
        url: '/order/buyer/order/manage/pay',
        method: 'post',
        data
    })
}

// 获取短信验证码
export function getOrderVerifyCode(phone) {
    return request({
        url: '/order/buyer/order/manage/send/' + phone,
        method: 'get',
    })
}

// 交易大厅-摘牌
export function goodsPurchase(data) {
    return request({
        url: '/order/buyer/order/manage/create',
        method: 'post',
        data
    })
}

// -------------------- /order/seller/ --------------------

// 卖家订单分页查询
export function getSellerOrderList(query) {
    return request({
        url: '/order/seller/order/manage/page',
        method: 'get',
        params: query
    })
}

// 卖家订单详情查询
export function getSellerOrderDetail(orderCode) {
    return request({
        url: '/order/seller/order/manage/detail/' + orderCode,
        method: 'get'
    })
}

// 卖家订单发货
export function orderDeliver(data) {
    return request({
        url: '/order/seller/order/manage/deliver',
        method: 'post',
        data
    })
}

// 卖家取消订单
export function sellerCancelOrder(data) {
    return request({
        url: '/order/seller/order/manage/cancel',
        method: 'post',
        data
    })
}

// 查询当前订单买卖双方收货地址信息
export function getAddressInfo(orderCode) {
    return request({
        url: '/order/seller/order/manage/address/info/' + orderCode,
        method: 'get'
    })
}

// 获取物流列表
export function getLogisticsList(query) {
    return request({
        url: '/order/seller/order/manage/logistics/page',
        method: 'get',
        params: query
    })
}

// 物流详情查询
export function getLogisticsDetail(orderCode) {
    return request({
        url: '/order/seller/order/manage/logistics/detail/' + orderCode,
        method: 'get',
    })
}

// 更新物流动态
export function updateLogistics(data) {
    return request({
        url: '/order/seller/order/manage/update/logistics/record',
        method: 'post',
        data: data
    })
}

// -------------------- /order/common/ --------------------

// 交易中心查询
export function getTradingCenter(query) {
    return request({
        url: '/order/common/order/transaction/center/statistics',
        method: 'get',
        params: query
    })
}

// 交易情况查询
export function getTradingSituation(query) {
    return request({
        url: '/order/common/order/transaction/situation/statistics',
        method: 'get',
        params: query
    })
}

// 签约订单查询
export function getSignOrderPage(query) {
    return request({
        url: '/order/common/order/page',
        method: 'get',
        params: query
    })
}

// 获取商品状态类型
export function getStatusType(params) {
    return request({
        url: '/order/common/order/statuses',
        method: 'get',
        params
    })
}

// 违规记录查询
export function getBreakContract(params) {
    return request({
        url: '/order/common/order/default/page',
        method: 'get',
        params
    })
}

// 确认处罚结果
export function getAffirmBreak(params) {
    return request({
        url: '/order/common/order/default/penalty/',
        method: 'get',
        params
    })
}

// -------------------- /order/seal/ --------------------

// 签章管理-查询签章
export function getSignature(params) {
    return request({
        url: '/order/seal/query/user/seals',
        method: 'get',
        params
    })
}

// 签章管理-设置默认章
export function setDefaultSign(data) {
    return request({
        url: '/order/seal/set/default/seal/' + data,
        method: 'post'
    })
}

// 签章管理-删除签章
export function delSealInfo(data) {
    return request({
        url: '/order/seal/remove/' + data,
        method: 'delete'
    })
}

// 签章管理-添加签章
export function addSignature(data) {
    return request({
        url: '/order/seal/create',
        method: 'post',
        data,
        headers: {
            "Content-Type": 'multipart/form-data'
        }
    })
}

// 签章管理-编辑签章
export function redactSignature(data) {
    return request({
        url: '/order/seal/enterprise/user/add',
        method: 'post',
        data,
        headers: {
            "Content-Type": 'multipart/form-data'
        }
    })
}
